/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Owner_OnlyInputs */

const en_adm_err_owner_only = /** @type {(inputs: Adm_Err_Owner_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only owners can change owner accounts or the owner flag.`)
};

const de_adm_err_owner_only = /** @type {(inputs: Adm_Err_Owner_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Eigentümer können Eigentümer-Konten oder die Eigentümer-Markierung ändern.`)
};

/**
* | output |
* | --- |
* | "Only owners can change owner accounts or the owner flag." |
*
* @param {Adm_Err_Owner_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_owner_only = /** @type {((inputs?: Adm_Err_Owner_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Owner_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_owner_only(inputs)
	return en_adm_err_owner_only(inputs)
});